export default __webpack_public_path__ + "static/media/022-candy.503bcf25.svg";